import styled from 'styled-components';

export const SubmitButton = styled.button`
height: 40px;
width 100px;
color: #26313C;
border: none;
width: 100%;
border-radius: 40px;
background-color: #26313C;
color: white;
cursor: pointer;
margin-top: 20px;

 &:hover{
     background-color: #e6e6e6;
     color: #26313C;
 }
`